import moment from "moment";
import config from "config/config.js";

const paymentPayPal = (
  restaurantId,
  data,
  details,
  dish,
  shippingInfo,
  totalPrice,
  deliveryPrice,
  servicePrice,
  subPrice,
  language,
  typeOfPayment,
  howPay = "",
  userId = ""
) => {
  let endpoint = `${config.baseUrl}/no-cors/delivery/paypal`;

  if (shippingInfo && shippingInfo.type === "Reservation") {
    endpoint = `${config.baseUrl}/no-cors/delivery/reservation`;
  }
  // const xsrfToken = getFreshToken();
  // const endpoint = `${config.baseUrl}/api/backofficeRoute/delivery/${id}`;

  const time = shippingInfo.time;
  const day = moment(shippingInfo.date).format("YYYY/MM/DD");

  const body = Object.assign({}, data, details, {
    // restaurantId: RESTAURANT_ID, //"58c6cce4d6cc5a36f06a8c68",
    restaurantId,
    language,
    price: totalPrice,
    dish, // tutti i piatti con i relativi ingredienti e prezzo,
    userId, // se mettiamo il login
    /* ************
    // SHIPPING INFO
      city,
      cap,
      address,
      indoor,
      floor,
      telephoneDelivery,
      date,
      time,
    // CONTACTS
      firstName,
      lastName,
      email,
      telephone
    // PAYMENT
    ************** */
    billingData: shippingInfo,
    time,
    day,
    deliveryPrice,
    servicePrice,
    subPrice,
    howPay,
    typeOfPayment,
    note: shippingInfo.note ? shippingInfo.note : "",
    polygonId: shippingInfo.polygonId ? shippingInfo.polygonId : null
    // tutti i dati per la spedizione
  });

  const options = {
    method: "post",
    mode: "cors",
    headers: {
      // "Access-Control-Allow-Origin": "https://www.foodiestrip.com",
      // "Access-Control-Allow-Credentials": true,
      Accept: "application/json",
      "Content-Type": "application/json"
      // "X-XSRF-TOKEN": xsrfToken
    },
    // credentials: "include"
    body: JSON.stringify(body)
  };

  return fetch(endpoint, options)
    .then(response => {
      return response.json();
    })
    .then(res => {
      if (res) {
        return res;
      }
      return null;
    })
    .catch(e => {
      // eslint-disable-next-line no-console
      // console.log("errrr", e);
      return null;
    });
};

export default paymentPayPal;
